import { useState } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import clsx from "clsx";
import type { IAuditoriaEventoSalvar } from "@/api/space/dtos/authenticator.dto";
import { rotuloContagem } from "../auditoria.utils";
import CabecalhoEvento from "./CabecalhoEvento";
import ChipResumo from "./ChipResumo";
import SecaoTelaPermissoes from "./SecaoTelaPermissoes";

/** Card de evento "Alteração de acessos": resumo + telas com permissões aninhadas (expansível). */
export default function CardEventoSalvar({ evento }: { readonly evento: IAuditoriaEventoSalvar }) {
	const [aberto, setAberto] = useState(false);

	const inseridos = evento.resumo.permissoes.inseridos + evento.resumo.recursos.inseridos;
	const ativados = evento.resumo.permissoes.ativados + evento.resumo.recursos.ativados;
	const desativados = evento.resumo.permissoes.desativados + evento.resumo.recursos.desativados;
	const semEfeito = inseridos === 0 && ativados === 0 && desativados === 0;
	const temDetalhes = evento.telas.length > 0;

	return (
		<div className="rounded-md border border-border/60 bg-card shadow-sm">
			<button
				type="button"
				onClick={() => temDetalhes && setAberto((valor) => !valor)}
				className={clsx(
					"flex w-full items-center gap-3 p-3 text-left",
					temDetalhes ? "hover:cursor-pointer hover:bg-muted/40" : "cursor-default",
				)}
			>
				<CabecalhoEvento evento={evento} />
				{temDetalhes ? (
					<FuseSvgIcon size={18} className="shrink-0 text-muted-foreground">
						{aberto ? "lucide:chevron-up" : "lucide:chevron-down"}
					</FuseSvgIcon>
				) : null}
			</button>

			<div className="flex flex-wrap gap-1.5 px-3 pb-3 pl-15">
				{semEfeito ? <ChipResumo tom="muted">Sem alterações efetivas</ChipResumo> : null}
				{inseridos > 0 ? (
					<ChipResumo tom="info">{rotuloContagem(inseridos, "inserido", "inseridos")}</ChipResumo>
				) : null}
				{ativados > 0 ? (
					<ChipResumo tom="success">{rotuloContagem(ativados, "ativado", "ativados")}</ChipResumo>
				) : null}
				{desativados > 0 ? (
					<ChipResumo tom="danger">{rotuloContagem(desativados, "desativado", "desativados")}</ChipResumo>
				) : null}
			</div>

			{aberto && temDetalhes ? (
				<div className="flex flex-col gap-2 border-t border-border/60 px-3 py-3">
					{evento.telas.map((tela) => (
						<SecaoTelaPermissoes key={tela.tag} tela={tela} />
					))}
				</div>
			) : null}
		</div>
	);
}
